<template>
    <div class="form-container" style="max-width: 900px; margin: auto;">
        <h2>Physician Determination</h2>
        <hr class="bold-hr" />

        <div v-if="loading" class="text-center">
            <span class="spinner-border spinner-border-sm"></span> Loading...
        </div>

        <form v-else @submit.prevent="submitForm">

            <label class="mt-2">Determination Note</label>
            <textarea v-model="form.determination_note" class="form-control"></textarea>
            <div v-if="errors.determination_note" class="text-danger">{{ errors.determination_note[0] }}</div>

            <label class="mt-2">Approved Phase (0-7) *</label>
            <input type="number" v-model.number="form.approved_phase" class="form-control" min="0" max="7">
            <div v-if="errors.approved_phase" class="text-danger">{{ errors.approved_phase[0] }}</div>

            <label class="mt-2">Approved Schedule *</label>
            <div class="d-flex flex-wrap gap-3">
                <div v-for="day in days" :key="day" class="d-flex align-items-center gap-1">
                    <input type="checkbox" :value="day" v-model="form.approved_schedule" />
                    <span>{{ day }}</span>
                </div>
            </div>
            <div v-if="errors.approved_schedule" class="text-danger">{{ errors.approved_schedule[0] }}</div>

            <label class="mt-2">PMP Report Reviewed *</label>
            <div class="d-flex gap-4 mt-2">
                <label class="d-flex align-items-center gap-1">
                    <input type="radio" :value="true" v-model="form.pmp_report_reviewed" /> Yes
                </label>
                <label class="d-flex align-items-center gap-1">
                    <input type="radio" :value="false" v-model="form.pmp_report_reviewed" /> No
                </label>
            </div>
            <div v-if="errors.pmp_report_reviewed" class="text-danger">{{ errors.pmp_report_reviewed[0] }}</div>

            <label class="mt-2">Result Notes</label>
            <textarea v-model="form.result_notes" class="form-control"></textarea>
            <div v-if="errors.result_notes" class="text-danger">{{ errors.result_notes[0] }}</div>

            <div class="mt-3">
                <button class="btn btn-sm btn-primary" type="submit">
                    {{ isEditing ? 'Save' : 'Save' }}
                </button>

                <button class="btn btn-sm btn-secondary ms-2" type="button" @click="cancel">
                    Cancel
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isEditing: false,
            loading: false,
            form: {
                phase_determination_id: this.$route.params.phase_determination_id || '',
                approved_phase: '',
                approved_schedule: [],
                pmp_report_reviewed: '',
                result_notes: '',
                determination_note: '',
            },
            days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            errors: {},
            student_id: '',
        };
    },
    mounted() {
        if (this.$route.name === 'PhysicianDeterminationEdit') {
            this.isEditing = true;
            this.loadData();
        } else {
            this.loadPhaseDetermination();
        }
    },
    methods: {
        async loadData() {
            this.loading = true;
            const res = await this.$api.get(`/physician-determinations/${this.$route.params.id}`);
            this.form = {
                phase_determination_id: res.data.phase_determination_id,
                approved_phase: res.data.approved_phase,
                approved_schedule: res.data.approved_schedule || [],
                pmp_report_reviewed: res.data.pmp_report_reviewed,
                result_notes: res.data.result_notes,
                determination_note: res.data.determination_note,
            };
            this.student_id = res.data.phase_determination.student_id;
            this.loading = false;
        },

        async loadPhaseDetermination() {
            this.loading = true;
            const res = await this.$api.get(`/phase-determinations/${this.$route.params.phase_determination_id}`);
            this.form.phase_determination_id = res.data.id;
            this.student_id = res.data.student_id;
            this.loading = false;
        },

        cancel() {
            this.$router.push({
                name: 'PhaseDeterminationDetail',
                params: { student_id: this.student_id }
            });
        },

        async submitForm() {
            try {
                if (this.isEditing) {
                    await this.$api.put(`/physician-determinations/${this.$route.params.id}`, this.form);
                } else {
                    await this.$api.post(`/physician-determinations`, this.form);
                }

                this.$router.push({
                    name: 'PhaseDeterminationDetail',
                    params: { student_id: this.student_id }
                });

            } catch (err) {
                if (err.response?.status === 422) {
                    this.errors = err.response.data.errors;
                }
            }
        },
    },
};
</script>

<style scoped>
.text-danger {
    font-size: 12px;
}

.bold-hr {
    height: 3px;
    background-color: black;
    border: none;
}
</style>
